import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { TaskCalculationFileInterface } from './definitions/task-calculation-file-interface';
import { ErrorsInterface } from '../errors/errors-interface';
import { taskDetailQuery } from '../../../../admin/task-detail/task-detail.data';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';
import { cloneDeep } from '@apollo/client/utilities';

interface CalculationFileUploadResponse {
  taskCalculationFile: {
    upload: {
      output: TaskCalculationFileInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class UploadTaskCalculationFileService {
  constructor(private apollo: Apollo) {}

  uploadCalculation(
    taskId: string,
    name: string,
    content: string,
    extension: string,
    mutation: DocumentNode,
    customPlaceHolderId?: string
  ): Observable<FetchResult<CalculationFileUploadResponse>> {
    return this.apollo.mutate<CalculationFileUploadResponse>({
      mutation: mutation,
      variables: {
        taskId: taskId,
        name: name,
        content: btoa(content),
        extension: extension,
      },
      optimisticResponse: {
        taskCalculationFile: {
          upload: {
            output: {
              id: customPlaceHolderId
                ? customPlaceHolderId
                : '-' + Math.random(),
              task: null,
              size: 0,
              createdAt: new Date(),
              updatedAt: new Date(),
              removedAt: null,
              type: null,
              src: null,
              thumbnails: [],
              taskId: taskId,
              name: name,
              extension: extension,
            },
            errors: {
              errors: [],
              status: 0,
              message: '',
              errorData: null
            },
          },
        },
      },
      update: (proxy, mutationResult) => {
        let data = <{ task: any }>(
          proxy.readQuery({ query: taskDetailQuery, variables: { id: taskId } })
        );
        if (
          mutationResult.data.taskCalculationFile.upload.output !== undefined &&
          mutationResult.data.taskCalculationFile.upload.output !== null
        ) {
          data = cloneDeep(data);
          data.task.byId.output.taskCalculationFiles.push(
            mutationResult.data.taskCalculationFile.upload.output
          );
        }
        proxy.writeQuery({
          query: taskDetailQuery,
          variables: { id: taskId },
          data,
        });
      },
    });
  }
}
